import { styled } from '@mui/material/styles';
import Box from '@mui/material/Box';

export const WrapperActions = styled(Box)(({ theme }) => ({
  display: 'flex',
  justifyContent: 'space-between',
  marginBottom: '56px',
  marginTop: '40px',

  [`.Stepper-root`]: {
    display: 'none',
    flexDirection: 'column',
    alignItems: 'flex-start'
  },

  ['.Stepper-numbers']: {
    backgroundColor: theme.palette.neutrals.beige1,
    border: `solid 1px ${theme.palette.neutrals.beige3}`
  },

  ['.Stepper-label']: {
    marginTop: '8px'
  },

  [theme.breakpoints.down('md')]: {
    marginTop: '24px'
  },

  [theme.breakpoints.down('md')]: {
    position: 'fixed',
    bottom: 0,
    left: 0,
    right: 0,
    backgroundColor: theme.palette.neutrals.beige2,
    margin: 0,
    alignItems: 'center',
    padding: ` ${theme.spacing(2)} ${theme.spacing(3)}`,

    [`.Stepper-root`]: {
      display: 'flex'
    }
  }
}));
